import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, MapPin, Building2 } from "lucide-react";
import { getCities } from "../../services/api";
import "./SearchBar.css";

const CATEGORIES = [
  { id: "residential", slug: "residential", name: "Residential" },
  { id: "commercial", slug: "commercial", name: "Commercial" },
  { id: "plots", slug: "plots", name: "Plots" },
];

function citySlug(c) {
  return (
    c.slug ||
    String(c.name || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-") ||
    c.id
  );
}

export default function SearchBar() {
  const navigate = useNavigate();
  const [category, setCategory] = useState(CATEGORIES[0].slug);
  const [city, setCity] = useState("");
  const [cities, setCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(true);

  useEffect(() => {
    let cancelled = false;

    getCities()
      .then((list) => {
        if (cancelled) return;
        const rows = Array.isArray(list) ? list : [];
        setCities(rows);
        if (rows.length && !city) {
          setCity(citySlug(rows[0]));
        }
      })
      .catch(() => {
        if (!cancelled) setCities([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingCities(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!city) return;

    // Prefer city page; category can be passed as query if you want both
    navigate(`/city/${city}${category ? `?category=${category}` : ""}`);

    // Or go to projects by category instead:
    // navigate(`/projects/${category}`);
  };

  return (
    <form onSubmit={handleSubmit} className="searchbar-form">
      <label className="search-field">
        <Building2 className="search-icon" />
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="search-select"
        >
          {CATEGORIES.map((cat) => (
            <option key={cat.id} value={cat.slug}>
              {cat.name}
            </option>
          ))}
        </select>
      </label>

      <label className="search-field">
        <MapPin className="search-icon" />
        <select
          value={city}
          onChange={(e) => setCity(e.target.value)}
          className="search-select"
          disabled={loadingCities || cities.length === 0}
        >
          {loadingCities && <option value="">Loading cities…</option>}
          {!loadingCities && cities.length === 0 && (
            <option value="">No cities</option>
          )}
          {cities.map((c) => (
            <option key={c.id || c.name} value={citySlug(c)}>
              {c.name}
            </option>
          ))}
        </select>
      </label>

      <button
        type="submit"
        className="search-btn"
        disabled={!city || loadingCities}
      >
        <Search className="h-4 w-4" />
        Search
      </button>
    </form>
  );
}